import { EventAnalyticsRevenueAllTimeDto } from 'legacy/events/types';

import { useQuery } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { getEventAnalyticsRevenueAllTime } from '../service';

export function useEventAnalyticsRevenueAllTime({
  eventId
}: {
  eventId: string;
}) {
  return useQuery<EventAnalyticsRevenueAllTimeDto, ErrorResponse>(
    ['items', { eventId }],
    () => getEventAnalyticsRevenueAllTime({ eventId })
  );
}
